import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { PresentationService } from '../../../core/services/presentation.service';
import { PresentationsActions } from './presentations.actions';

export const loadPresentations$ = createEffect(
  (actions$ = inject(Actions), presentationService = inject(PresentationService)) =>
    actions$.pipe(
      ofType(PresentationsActions.loadPresentations),
      switchMap(({ page, perPage }) =>
        presentationService.list(page, perPage).pipe(
          map((response) => PresentationsActions.loadPresentationsSuccess({ response })),
          catchError((error: Error) =>
            of(PresentationsActions.loadPresentationsFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  { functional: true },
);

export const downloadPresentation$ = createEffect(
  (actions$ = inject(Actions), presentationService = inject(PresentationService)) =>
    actions$.pipe(
      ofType(PresentationsActions.downloadPresentation),
      // download() returns a cold Observable — it must be subscribed to for the
      // authenticated request to fire and the presigned URL to open. mergeMap
      // subscribes; catchError keeps the effect stream alive on a failed
      // download (the HTTP interceptor already surfaces the error to the user).
      mergeMap(({ id }) =>
        presentationService.download(id).pipe(catchError(() => EMPTY)),
      ),
    ),
  { functional: true, dispatch: false },
);
